/*
*
* A valuable is an object that, given a character, a raw value, a UI and an optional type, can return a value.
* It has two functions:
* * match(raw, type): gets a raw string and an optional expected type returns true if it can return a value for it.
* * async getValue({ character, raw, ui, type, context }): gets a character, context, raw value a UI and an optional type and returns return the matching value.
*
*/
export default class Valuable {
  match (raw, type) {
    throw new Error('Cannot call method match on Valuable class directly')
  }

  async getValue ({ character, raw, ui, type }) {
    throw new Error('Cannot call method getValue on Valuable class directly')
  }
}
